export const az = {
  title: 'Torpaq örtüyü 2015',
  subtitle: 'ESA/UCLouvain, 2015',
  download_data: 'http://maps.elie.ucl.ac.be/CCI/viewer/download.php',
  learn_more: 'http://maps.elie.ucl.ac.be/CCI/viewer/download/ESACCI-LC-Ph2-PUGv2_2.0.pdf',
  content: [
    {
      label: 'Funksiya',
      value: '2015-ci ildə torpaq örtüyünün qlobal paylanmasını göstərir',
    },
    {
      label: 'Qətmə',
      value: '300 × 300 metr',
    },
    {
      label: 'Coğrafi əhatə',
      value: 'Qlobal',
    },
    {
      label: 'Mənbə',
      value: '© ESA İqlim Dəyişmə təşəbbüsü - UCLouvain-in rəhbərlik etdiyi torpaq örtüyü (2017)',
    },
    {
      label: 'Tezlik',
      value: 'İllik',
    },
    {
      label: 'Məzmun tarixi',
      value: '2015',
    },
    {
      label: 'Xəbərdarlıqlar',
      value:
        'Tam dəqiqlik qiymətləndirməsi CCI-dən əldə edilə bilər. Ümumiyyətlə, yağış və suvarılan əkin sahələri, geniş meşələr, şəhər yerləri, çılpaq ərazilər, su cəsədləri və daimi qar kimi torpaq örtüyü sinifləri olduqca dəqiq xəritədə tapılır. Digər tərəfdən, liçen və yosun, az bitki örtüyü və şirin su ilə dolu meşə kimi siniflərə səhvlər təsir edə bilər.\n\nVerilənlərin keyfiyyəti regionlara görə dəyişir, xüsusilə də baza xəritəsinin yaradılması üçün MERIS təsvirlərinin əhatə dairəsi ilə bağlıdır. Daha az əhatə dairəsinə malik olan ərazilərə Amazon hövzəsinin qərb hissəsi, Çili və Argentinanın cənub hissəsi, Konqo hövzəsinin qərb hissəsi, həmçinin Qvineya körfəzi, Rusiyanın şərq hissəsi, Çin və İndoneziyanın şərq sahilləri daxildir.',
    },
    {
      label: 'Lisenziya',
      value: 'http://maps.elie.ucl.ac.be/CCI/viewer/download.php',
    },
  ],
  overview: {
    label: 'Ümumi baxış',
    value:
      'Bu məlumat dəsti (versiya 2.07) iqlimin modelləşdirilməsi məqsədləri üçün uzunmüddətli, ardıcıl, qlobal məlumatların yaradılması üzrə Avropa Kosmik Agentliyinin təşəbbüsü olan İqlim Dəyişmələri Təşəbbüsü (CCI) qismində yaradılmışdır. CCI Land Cover layihəsi 1992-ci ildən 2015-ci ilə qədər illik əsasda 300 m spatial qətnamədə ardıcıl qlobal torpaq örtüyü xəritələrini təqdim edir. Global Forest Watch platforması yalnız 2015-ci ilin torpaq örtüyü məlumatlarını nümayiş etdirir.\n\nİldən-ilə ardıcıllığı təmin etmək üçün hər il üçün torpaq örtüyü xəritələri bir baza torpaq örtüyü xəritəsindən alınır. Əsas xəritə 2003-2012-ci illərdə MERIS şəkillərinin tam rekordundan istifadə edərək yaradılmışdır. Xəritədə nəzarətsiz klassifikasiya, eləcə də bir neçə illik rəsm üzərində maşın öyrənmə alqoritmi istifadə edilmişdir. Bundan sonra 1 km həlletmədə ayrı-ayrı illər arasında dəyişikliklər aşkarlanır, 1992-1999-cu illərdə AVHRR məlumatlarından, 1999-cu ildən 2013-cü ilə qədər SPOT-VGT məlumatlarından, 2014 və 2015-ci illərdə proVA-V məlumatlarından istifadə olunur. 2014-cü və 2015-ci illərdə baş verən meşə dəyişiklikləri istisna olmaqla, iki il ardıcıl olaraq dəyişikliklər ardıcıl olmalıdır. Bu dəyişikliklər yaxşı aşkar edildiyi güman edilir. 2004-cü ildə 300 metrdən çox olan 2004-cü ildə (MERIS və PROVA-V məlumatları əldə edildikdə) 1 km-ə qədər dəyişikliklər baza torpaq örtüyü xəritəsi ilə birləşdirilir.\n\n2002-ci ildə 22 nəfər təşkil etmişdir. Daha yaxşı vizualizasiya naminə, Global Forest Watch yalnız sadələşdirilmiş siniflər dəsti göstərir, ipCC əsasında (kənd təsərrüfatı, meşə, otlaq, nəm torpaq, yaşayış, shrubland, sparse bitki, çılpaq ərazi, su, daimi buz və qar). 1992-ci ilə qədər olan siniflərin tam dəsti, eləcə də illik torpaq örtüyü xəritələri ESA/CCI tamaşaçısı üzərində mövcuddur.',
  },
  citation: {
    label: 'Sitat',
    value:
      'ESA Climate Change Initiative, Land Cover - led by UC Louvain. “2015 global land cover.” Land Cover CCI Product User Guide Version 2. Tech. Rep. (2017). Available at: maps.elie.ucl.ac.be/CCI/viewer/download/ESACCI-LC-Ph2-PUGv2_2.0.pdf. Accessed through Global Forest Watch on 14/02/2025. www.globalforestwatch.org.',
  },
};
